import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { sessionExpired } from '@/shared/api/sessionEvents';

export type Theme = 'light' | 'dark';

interface NavState {
  isShowMenu: boolean;
  isShowSideBar: boolean;
  theme: Theme;
}

// One `{ key, value }` pair per field, so the value type follows the key
type NavSetPropPayload = {
  [K in keyof NavState]-?: { key: K; value: NavState[K] };
}[keyof NavState];

const INITIAL_STATE: NavState = {
  isShowMenu: false,
  isShowSideBar: false,
  theme: 'light',
};

const navSlice = createSlice({
  name: 'nav',
  initialState: INITIAL_STATE,
  reducers: {
    navSetProp: (state, action: PayloadAction<NavSetPropPayload>) => {
      const { key, value } = action.payload;
      Object.assign(state, { [key]: value });
    },

    logout: () => INITIAL_STATE,
  },
  extraReducers: (builder) => {
    builder.addCase(sessionExpired, () => INITIAL_STATE);
  },
});

export const { navSetProp, logout } = navSlice.actions;
export const navReducer = navSlice.reducer;
